import { motion } from "framer-motion";
import about_me_pic from "../../../Assets/Images/profile.jpg";
import SocialIcons from "./SocialIcons";
import { fadeUp, revealOnce, stagger } from "../../motion";
import "../../css/WelcomeAbout.css";

const INFO = [
  { label: "Name", value: "Akinola Daniel Oshinubi" },
  { label: "Location", value: "Lekki, Lagos State, Nigeria" },
  { label: "Email", value: "danieloshinubi@gmail.com", accent: true },
  {
    label: "Education",
    value: "BSc (Hons) Computer Science — Babcock University (2023), CGPA 4.06/5.00",
  },
];

const WelcomeAbout = () => {
  return (
    <section className="section welcome">
      <motion.div
        className="welcome__grid container"
        variants={stagger}
        {...revealOnce}
      >
        <motion.div className="welcome__media" variants={fadeUp}>
          <img src={about_me_pic} alt="Daniel Oshinubi" loading="lazy" />
        </motion.div>

        <motion.div className="welcome__body" variants={fadeUp}>
          <span className="eyebrow">IT Systems Engineer &amp; Developer</span>
          <h2 className="welcome__title">
            Over 5 years of professional experience
          </h2>
          <p className="welcome__text">
            I deliver dependable IT infrastructure and the software that runs on
            it. With a strong technical background spanning networking, security,
            and full-stack development — and Microsoft and ISC2 certifications
            behind me — I keep systems reliable while building efficient,
            user-focused applications.
          </p>

          <dl className="welcome__info">
            {INFO.map((item) => (
              <div key={item.label} className="welcome__info-row">
                <dt>{item.label}</dt>
                <dd className={item.accent ? "is-accent" : ""}>{item.value}</dd>
              </div>
            ))}
          </dl>

          <div className="welcome__actions">
            <a
              href="https://drive.google.com/file/d/1YW9gklTe1oP5hpoMu8ijwgLQbIELLJjY/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Download my resume
            </a>
            <SocialIcons />
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default WelcomeAbout;
